import { Injectable } from '@angular/core';
import { LOGIN_PROVIDER, SOCIAL_LOGIN, WALLET_LOGIN } from '../common/interface/common.interface';
import { SOCIAL_LOGIN_PROVIDERS, WALLET_LOGIN_PROVIDERS } from '../common/constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  validateFileExtension(filename: string, supportive_type: Array<string>) {
    let extension: string | undefined = filename.split('.').pop()?.toLowerCase();
    return extension ? supportive_type.indexOf(extension) > -1 : false;
  }

  validateFileSize(filesize: number, expected_size: number, option: 'KB' | 'MB' = 'MB') {
    let dividentvalue = option == 'KB' ? 1024 : 1024 * 1024;
    let size = filesize / dividentvalue;

    return  size <= expected_size;
  }

  isSocialLogin(provider: LOGIN_PROVIDER): boolean {
    return SOCIAL_LOGIN_PROVIDERS.includes(provider as SOCIAL_LOGIN);
  }

  isWalletLogin(provider: LOGIN_PROVIDER): boolean {
    return WALLET_LOGIN_PROVIDERS.includes(provider as WALLET_LOGIN);
  }
}
